'use client';

import { ACTIVITY_TYPE } from '@/consts/Activity';
import ModalBody from '@/features/Discovery/Modal/DiscoveryContentDetailModal/components/ModalBody';
import ReportModal from '@/components/ReportModal';
import { isReportModalOpened } from '@/features/Discovery/discovery.state';
import { sendGTMEvent } from '@next/third-parties/google';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useGetContentDetail } from '@/features/Discovery/Modal/DiscoveryContentDetailModal/hook/api';

const DiscoveryDetailComponent = () => {
  const { data } = useGetContentDetail();

  const [reportModalVisible, setReportModalVisible] =
    useAtom(isReportModalOpened);

  useEffect(() => {
    sendGTMEvent({ event: 'page__view' });
  }, []);

  return (
    <>
      <ReportModal
        visible={reportModalVisible}
        setVisible={setReportModalVisible}
        type={ACTIVITY_TYPE.discovery}
        typeId={data?.content?.id}
      />
      <ModalBody />
    </>
  );
};

export default DiscoveryDetailComponent;
